import { render, staticRenderFns } from "./MarcacoesLocalRelogio.vue?vue&type=template&id=ea5e0fba&"
import script from "./MarcacoesLocalRelogio.vue?vue&type=script&lang=js&"
export * from "./MarcacoesLocalRelogio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports